module.exports = {
      id: "smile-usage",
      viewBox: "0 0 17 17",
      url: "img/" + "sprite.svg#smile-usage",
      toString: function () {
        return this.url;
      }
    }